import { composeClassNames } from "@faedev/editor-utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { Col, Row } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import Heading from "src/components/Heading";
import Page from "src/components/Page";
import Paragraph from "src/components/Paragraph";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import getDefaultOg from "src/functions/getDefaultOg";
import { sLink } from "src/styles/sLink.module.scss";
import { sPageContacts } from "src/styles/sPageContacts.module.scss";

export default function Contacts() {
  const { locale: lang } = useRouter();

  return (
    <>
      <Headers data={getDefaultOg(lang)} />
      <Page className={composeClassNames([sPageContacts, "page-contacts"])}>
        <Header />
        <Content fluid={`xl`}>
          <Heading type="h1" title={<Translate tKey={`Contacts`} />} />
          <Row>
            <Col xs={12} sm={4} md={3}>
              <Heading
                type="h4"
                title={<Translate tKey={`Product and partnership`} />}
              />
              <Paragraph>
                <Text size="md" width={`semibold`}>{`Pavol Hudran`}</Text>
                <br />
                <Link href={`mailto:pavol.hudran@vivido.fit`} passHref>
                  <a className={sLink}>{`pavol.hudran@vivido.fit`}</a>
                </Link>
                <br />
                {`+420 775 210 833`}
                <br />
                <Translate tKey={`ID`} />
                {`: `}
                {74869663}
              </Paragraph>
            </Col>
            <Col xs={12} sm={4} md={3}>
              <Heading
                type="h4"
                title={<Translate tKey={`Marketing and sales`} />}
              />
              <Paragraph>
                <Text size="md" width={`semibold`}>{`Jana Rachno`}</Text>
                <br />
                <Link href={`mailto:jana.rachno@vivido.fit`} passHref>
                  <a className={sLink}>{`jana.rachno@vivido.fit`}</a>
                </Link>
                <br />
                {`+420 792 308 798`}
              </Paragraph>
            </Col>
            <Col xs={12} sm={4} md={3}>
              <Heading
                type="h4"
                title={
                  <Translate
                    tKey={`Profiles of instructors, studies and festivals`}
                  />
                }
              />
              <Paragraph>
                <Text size="md" width={`semibold`}>{`Žofie Vitešníková`}</Text>
                <br />
                <Link href={`mailto:zofie.vitesnikova@vivido.fit`} passHref>
                  <a className={sLink}>{`zofie.vitesnikova@vivido.fit`}</a>
                </Link>
                <br />
                {`+420 725 753 011`}
              </Paragraph>
            </Col>
            <Col xs={12} sm={4} md={3}>
              <Heading
                type="h4"
                title={<Translate tKey={`Technology and development`} />}
              />
              <Paragraph>
                <Text size="md" width={`semibold`}>{`Vojtěch Šalda`}</Text>
                <br />
                <Link href={`mailto:vojtech.salda@gmail.com`} passHref>
                  <a className={sLink}>{`vojtech.salda@gmail.com`}</a>
                </Link>
                <br />
                {`+420 775 649 476`}
              </Paragraph>
            </Col>
          </Row>
        </Content>
        <Footer />
        <Footers />
      </Page>
    </>
  );
}
